export default class Resource {
  id = 0;

  name = '';

  location_id = 0;

  parent_id = 0;
}
